module.exports = __webpack_public_path__ + "95e7f469d4e7bfa5a2ef9fc9094ad6d3.pdf";